import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ViewTableComponent } from '../../base/view-table/view-table.component';

@Component({
  selector: 'app-appointment-sheet',
  templateUrl: './appointment-sheet.component.html',
  styleUrls: ['./appointment-sheet.component.css']
})
export class AppointmentSheetComponent extends ViewTableComponent implements OnInit {

  currentPage: number;

  override displayedColumns: string[] = [
    'field_date_and_time_value',
    'time',
    'event_title',
    'enrollment_category',
    'field_total_lessons_taken_value',
    'field_total_lessons_remaining_value',
    'payment_due',
    'field_upcoming_lesson_value'
  ];

  formatLessonTime(value: string | number | null | undefined): string {
    const formattedTime = this.reportDateService.formatTime(value);
    return formattedTime.replace(/ [AP]M$/, '');
  }

  formatLessonMeridiem(value: string | number | null | undefined): string {
    return this.reportDateService.formatTime(value).split(' ').pop() || '';
  }

  override getData(params: { parameter: string; value: string; }[]) {
    this.ShowProgressBar = true;
    this.queryParams = params;

    // Load the new data with the filtering parameters.
    let endpoint: string = "/api_rest/v1/reports/appointment-sheet";

    this._drupalRESTService.httpGET(endpoint, params)
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;

        this.dataSource = new MatTableDataSource(data['results']);

        // // Pagination
        if (data['results']) {
          this.setupPagination(data, params);
        }
      },
        error => this.handleError(error)
      )
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }
    // DO NOT call updateRouterParams here - prevents duplicate requests
  }
}
